import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletContextProvider } from './WalletContext';
import { EntitlementsProvider } from './EntitlementsContext';
import { JWTAuthProvider } from './auth/JWTAuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from './components/Toast';
import AuthManager from './components/AuthManager';
import AppNavigation from './AppNavigation';
import Landing from './Landing';
import Game from './Game';
import ThemeCreator from './ThemeCreator';
import Profile from './Profile';
import Admin from './Admin';
import Heroes from './pages/Heroes';
import HeroDetail from './components/heroes/HeroDetail';
import Leaderboards from './pages/Leaderboards';
import BattleSimulator from './pages/BattleSimulator';
import BattleDetail from './pages/BattleDetail';
import BattlefieldManagement from './pages/BattlefieldManagement';
import Account from './pages/Account';
import Shop from './Shop';
import AdminBattlefieldTokens from './pages/AdminBattlefieldTokens';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <WalletContextProvider>
      <JWTAuthProvider>
        <EntitlementsProvider>
          <ToastProvider>
            <AuthManager>
              <Router>
                <div className="App">

              <div className="relative">
                <AppNavigation menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
              </div>

              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/account" element={<Account />} />
                <Route path="/game" element={<Game />} />
                <Route path="/themes" element={<ThemeCreator />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/heroes" element={<Heroes />} />
                <Route path="/hero/:id" element={<HeroDetail />} />
                <Route path="/leaderboards" element={<Leaderboards />} />
                <Route path="/battle-simulator" element={<BattleSimulator />} />
                <Route path="/battle/:id" element={<BattleDetail />} />
                <Route path="/battlefields" element={<BattlefieldManagement />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/admin/battlefield-tokens" element={<AdminBattlefieldTokens />} />
              </Routes>
              <ToastContainer />
              </div>
            </Router>
            </AuthManager>
          </ToastProvider>
        </EntitlementsProvider>
      </JWTAuthProvider>
    </WalletContextProvider>
  );
}

export default App;
